import { usePortfolioList } from '~/requests/projects/usePortfolioList';
import { Menu } from 'semantic-ui-react';

import PopupMenu from './PopupMenu';
import { Link } from 'react-router-dom';
import { PopupMenuProps } from './types';
import { Portfolio } from '~/types/portfolio';
import { PopupMenuEmptyMessage } from './PopupMenuEmptyMessage';

export default function PortfoliosPopupMenu({ trigger, onClose }: PopupMenuProps) {
  const { data: portfolios, status } = usePortfolioList();

  return (
    <PopupMenu trigger={trigger} onClose={onClose} isLoading={status === 'loading'}>
      {portfolios?.length === 0 ? 
        <PopupMenuEmptyMessage message='No portfolios to display' />
        : portfolios?.map((portfolio: Portfolio) => (
          <Menu.Item
            key={portfolio.id}
            as={Link}
            to={`/portfolio/${portfolio.id}`}
            onClick={() => onClose()}
            className="legacy-popup-menu-item"
          >
            {portfolio.name}
          </Menu.Item>
        ))}
    </PopupMenu>
  );
};
